import React from 'react';

import { Link } from 'react-router-dom';

import {
  List,
  Datagrid,
  Create,
  FormTab,
  ReferenceArrayInput,
  ReferenceInput,
  CheckboxGroupInput,
  BooleanInput,
  TextInput,
  NumberInput,
  TextField,
  Toolbar,
  SaveButton,
  ListButton,
  Filter,
  SelectInput,
  DateInput,
  Show,
  SimpleShowLayout,
  DateField,
  BooleanField,
  FunctionField,
  translate as t,
} from 'admin-on-rest';

import { CardActions, FlatButton, Chip } from 'material-ui';
import Refresh from 'material-ui/svg-icons/navigation/refresh';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import ShowButton from '../components/button/ShowButton';
import { getTranslationByLocale } from '../utils/TranslationUtils';
// import CheckboxAndPriceInput from '../components/inputs/CheckboxAndPriceInput';
import RadioButtonForObjectInput from '../components/inputs/RadioButtonForObjectInput';
import TranslatableInput from '../components/inputs/TranslatableInput';
import SyncIdBuilder from '../components/inputs/SyncIdBuilder';
import PriceInput from '../components/inputs/PriceInput';
import WsabSelect from '../components/inputs/WsabSelect';
import VenuePublishButton from '../components/button/VenuePublishButton';
// import References from '../components/References';
// import CloneAssortment from '../components/CloneAssortment';
import VenuePreview from '../components/VenuePreview';
import SyncPreview from '../components/SyncPreview';
import VenueBookingSetup from '../components/VenueBookingSetup';
import IndicatorField from '../components/fields/IndicatorField';
import BookingLinkBuilder from '../components/inputs/BookingLinkBuilder';
import BookingIdInput from '../components/inputs/BookingIdInput';
import CoordinateInput from '../components/inputs/CoordinateInput';
import PercentageField from '../components/fields/PercentageField';
import PercentageInput from '../components/inputs/PercentageInput';
import TabbedForm from '../components/TabbedForm';
import TranslatableField from '../components/fields/TranslatableField';
import BookingAliasInput from '../components/inputs/BookingAliasInput';
import Section from '../components/utils/Section';
import OpenHoursBuilder from '../components/OpenHoursBuilder';
import timezones from '../components/OpenHoursBuilder/timezones';
import languageCodes from '../utils/language-codes';
import countryCodes from '../utils/country-codes';

const ShowActions = ({ basePath, refresh, translate, ...props }) => (
  <CardActions style={cardActionStyle}>
    <Link to={`/open-hours/${props.match.params.id}`}>
      <FlatButton primary label={translate('openHours')} />
    </Link>
    <ListButton basePath={basePath} />
    <FlatButton primary label="Refresh" onClick={refresh} icon={<Refresh />} />
  </CardActions>
);

export const VenueShow = t((props) => (
  <Show {...props} actions={<ShowActions {...props} />}>
    <SimpleShowLayout>
      <TranslatableField addLabel source="title" />
      <TranslatableField addLabel source="subtitle" />
      <DateField source="openingDate" />
      <TextField source="tableBooking.href" />
      <TextField source="tableBooking.overrideHref" />
      <BooleanField source="tableBooking.googleBookingEnabled" />
      <TextField source="mobileNumber" />
      <TextField source="email" />
      <TextField source="visitationAddress.addressLine1" />
      <TextField source="visitationAddress.city" />
      <TextField source="visitationAddress.zipCode" />
      <TextField source="visitationAddress.country" />
      <TextField source="takeAwayVisitationAddress.addressLine1" />
      <TextField source="takeAwayVisitationAddress.city" />
      <TextField source="takeAwayVisitationAddress.zipCode" />
      <TextField source="takeAwayVisitationAddress.country" />
      <TextField source="urls.jobApplication" options={{ fullWidth: true }} />
      <PercentageField source="tipLimitFactor" options={{ fullWidth: true }} />
      <TextField source="tipLimit.value" precision="market.currencyPrecision" />
      <PercentageField source="quickPayFactor" options={{ fullWidth: true }} />
      <TextField
        source="paynovaMaxAmount.value"
        precision="market.currencyPrecision"
      />
      <TextField source="paynovaLocationId" options={{ fullWidth: true }} />
      <TextField source="paynovaInvoiceMID" options={{ fullWidth: true }} />
      <TextField source="paynovaInvoiceMPW" options={{ fullWidth: true }} />
      <BooleanField source="billingAllowed" />
      <BooleanField source="deliveryEnabled" />
      <BooleanField source="pickupEnabled" />
      <BooleanField source="brunchEnabled" />
      <BooleanField source="anonymousOrderEnabled" />
      <BooleanField source="takeAwayEnabled" />
      <BooleanField source="creperieEnabled" />
      <BooleanField source="creperieTakeAwayEnabled" />
      <BooleanField source="isOpen" />
      <FunctionField
        source="supportedPSPs"
        render={(record) => (
          <div style={{ display: 'flex', flexFlow: 'row wrap' }}>
            {record.supportedPSPs.map((sPSP) => (
              <Chip>{sPSP}</Chip>
            ))}
          </div>
        )}
      />
      {/* <ChipField source="supportedPSPs" /> */}
      <TranslatableField addLabel source="reordering.message" />
      <TextField source="reordering.timeout" />
      <TextField source="extOrderData.externalId" addField {...props} />
      <TextField source="extData.externalId" />
      <TextField source="it.operations" />
      <TextField source="it.primaryNetwork" />
      <TextField source="it.backupNetwork" />
    </SimpleShowLayout>
  </Show>
));

const VenueFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      label="market"
      source="market"
      reference="markets"
      allowEmpty
      alwaysOn
    >
      <SelectInput optionText="countryCode" />
    </ReferenceInput>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

export const VenueList = (props) => {
  const { user } = props;
  const isSuperUser = user.superUser;
  const shouldSeeAllVenues = isSuperUser;
  const filter = shouldSeeAllVenues ? {} : { name: user.venues };
  return (
    <List {...props} filter={props.filter || filter} filters={<VenueFilter />} perPage={200}>
      <Datagrid>
        <IndicatorField label="Published" source="appIdWhitelist[0]" />
        <TranslatableField addLabel source="title" />
        <TextField source="name" />
        <EditButton {...props} basePath="/venues" />
        <ShowButton {...props} basePath="/venues" />
      </Datagrid>
    </List>
  );
};

const VenueTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

const title = (resource) => (
  <span>{getTranslationByLocale(resource.title, 'en')}</span>
);

const VenueToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
    {props.action === 'edit' && <VenuePublishButton {...props} />}
  </Toolbar>
);

const form = (action, props) => (
  <TabbedForm
    outerChildren={
      action === 'create' && [
        <ReferenceInput
          {...props}
          label=""
          source="market"
          reference="markets"
          allowEmpty
        >
          <RadioButtonForObjectInput optionText={title} />
        </ReferenceInput>,
      ]
    }
    redirect="list"
    toolbar={<VenueToolbar action={action} />}
  >
    <FormTab label="info">
      {action === 'create' && <TextInput source="name" />}
      {action === 'edit' && <TextField source="name" />}
      <TranslatableInput source="title" {...props} />
      <TranslatableInput source="subtitle" {...props} />
      <TextInput
        source="mobileNumber"
        type="tel"
        autoComplete="tel"
        options={{ fullWidth: true }}
      />
      <TextInput source="email" type="email" options={{ fullWidth: true }} />
      <SelectInput
        source="countryCode"
        label="countryCode"
        options={{ fullWidth: true }}
        choices={countryCodes}
      />
      <SelectInput
        source="languageCode"
        label="languageCode"
        options={{ fullWidth: true }}
        choices={languageCodes}
      />
      <SelectInput
        source="timezone"
        label="Timezone"
        defaultValue={action === 'create' ? 'Europe/Stockholm' : null}
        options={{ fullWidth: true }}
        choices={timezones.map((tz) => ({ id: tz, name: tz }))}
      />
      <TextInput
        source="visitationAddress.addressLine1"
        options={{ fullWidth: true }}
      />
      <TextInput
        source="visitationAddress.city"
        options={{ fullWidth: true }}
      />
      <TextInput
        source="visitationAddress.zipCode"
        options={{ fullWidth: true }}
      />
      <TextInput
        source="visitationAddress.country"
        options={{ fullWidth: true }}
      />
      <TextInput
        source="takeAwayVisitationAddress.addressLine1"
        options={{ fullWidth: true }}
      />
      <TextInput
        source="takeAwayVisitationAddress.city"
        options={{ fullWidth: true }}
      />
      <TextInput
        source="takeAwayVisitationAddress.zipCode"
        options={{ fullWidth: true }}
      />
      <TextInput
        source="takeAwayVisitationAddress.country"
        options={{ fullWidth: true }}
      />
      <CoordinateInput source="loc.coordinates" />
      <TextInput source="loc.coordinates[0]" options={{ fullWidth: true }} />
      <TextInput source="loc.coordinates[1]" options={{ fullWidth: true }} />
      <BooleanInput source="underMicroscope" />
      <SelectInput
        source="area"
        allowEmpty
        choices={[
          { name: props.translate('news.north'), id: 'north' },
          { name: props.translate('news.central'), id: 'central' },
          { name: props.translate('news.south'), id: 'south' },
        ]}
        options={{ fullWidth: true }}
      />
      <SelectInput
        source="classifications"
        choices={[
          { name: 'Storstad', id: 'Storstad' },
          { name: 'Kuststad', id: 'Kuststad' },
          { name: 'Ort > 50k', id: 'Ort > 50k' },
          { name: 'Ort < 50k', id: 'Ort < 50k' },
        ]}
        options={{ fullWidth: true }}
      />
      <TextInput source="urls.jobApplication" options={{ fullWidth: true }} />
      <TextInput source="urls.facebook" options={{ fullWidth: true }} />
      <TextInput source="urls.instagram" options={{ fullWidth: true }} />
      <TextInput source="urls.woltUrl" options={{ fullWidth: true }} />
      <TextInput source="urls.foodoraUrl" options={{ fullWidth: true }} />
      <TextInput source="urls.npsOverride" options={{ fullWidth: true }} />
      <TextInput
        source="urls.selectionOverride"
        options={{ fullWidth: true }}
      />
      <TextInput source="urls.editorial" options={{ fullWidth: true }} />
      <TextInput source="urls.editorialV2" options={{ fullWidth: true }} />

      <NumberInput source="floorSize" />
      <NumberInput source="temporarySeats" />
      <NumberInput source="rentMonthly" />
      <NumberInput source="tableAmount" />
      <BooleanInput source="openHours.locked" />
    </FormTab>

    <FormTab label="Booking">
      <BookingIdInput source="bookingId" label="Booking ID" />
      <BookingAliasInput
        multiple
        source="bookingAliases"
        label="Aliases"
        fullWidth
      />
      <DateInput source="openingDate" />
      <DateInput source="closingDate" />
      <BookingLinkBuilder {...props} source="tableBooking.href" />
      <TextInput
        source="tableBooking.overrideHref"
        options={{ fullWidth: true }}
      />
      <BooleanInput source="tableBooking.googleBookingEnabled" />
      <Section title="Printer">
        <BooleanInput source="printing.active" />
        <TextInput source="printing.channel" options={{ fullWidth: true }} />
        <TextInput source="printing.printer" options={{ fullWidth: true }} />
        <SelectInput
          source="printing.action"
          choices={[
            { name: 'Template', id: 'template' },
            { name: 'HTML', id: 'html' },
          ]}
          options={{ fullWidth: true }}
        />
        <TextInput source="printing.wifiCode" options={{ fullWidth: true }} />
      </Section>
    </FormTab>

    <FormTab label="organisation">
      <BooleanInput source="cashierDotCloud" />
      <SelectInput
        source="cashierDotCloudVersion"
        label="Cashier version (use 1.0.0 for all restaurants, except Berlin and Helsinki)"
        defaultValue={action === 'create' ? '1.0.0' : null}
        choices={[
          { name: '1.0.0', id: '1.0.0' },
          {
            name: '0.1',
            id: '0.1',
          },
        ]}
        options={{ fullWidth: true }}
      />
      <TextInput source="organisationName" options={{ fullWidth: true }} />
      <TextInput source="organisationNumber" options={{ fullWidth: true }} />
      <TextInput source="customerId" options={{ fullWidth: true }} />
      <TextInput source="franchiseGroup" options={{ fullWidth: true }} />
      <PercentageInput source="tipLimitFactor" />
      <PriceInput
        label="tipLimit"
        source="tipLimit.value"
        precision="market.currencyPrecision"
      />
      <PercentageInput source="quickPayFactor" />
      <PriceInput
        label="paynovaMaxAmount"
        source="paynovaMaxAmount.value"
        precision="market.currencyPrecision"
        currencyCode="market.currencyCode"
      />
      <TextInput source="adyenMID" options={{ fullWidth: true }} />
      <TextInput source="adyenTerminalMID" options={{ fullWidth: true }} />
      <TextInput source="swishMID" options={{ fullWidth: true }} />
      <TextInput source="vippsMID" options={{ fullWidth: true }} />
      <TextInput source="bamboraMID" options={{ fullWidth: true }} />
      <TextInput source="bamboraMN" options={{ fullWidth: true }} />
      <TextInput source="googleBusinessProfileID" options={{ fullWidth: true }} />
      <BooleanInput source="billingAllowed" />
      <BooleanInput source="deliveryEnabled" />
      <BooleanInput source="pickupEnabled" />
      <BooleanInput source="takeAwayEnabled" />
      <BooleanInput source="creperieEnabled" />
      <BooleanInput source="creperieTakeAwayEnabled" />
      <BooleanInput source="isOpen" />
      <BooleanInput source="xSale" />
      <BooleanInput source="showRating" />
      <BooleanInput source="showGuestFeedback" />
      <BooleanInput source="autoActivation" />
      <BooleanInput source="anonymousOrderEnabled" />
      <BooleanInput source="premiere" />
      <TranslatableInput source="reordering.message" {...props} />
      <NumberInput source="reordering.timeout" />
      <ReferenceArrayInput
        {...props}
        source="supportedPSPs"
        reference="psps"
        allowEmpty
      >
        <CheckboxGroupInput />
      </ReferenceArrayInput>
      {action === 'edit' && (
        <WsabSelect source="extOrderData.externalId" addField {...props} />
      )}
      {action === 'edit' && <SyncIdBuilder source="extData.externalId" />}
      <TextInput source="legacyVenueId" />
      <TextInput source="jobOfficeGiftcardId" />
      <TextInput source="caspeco" />
      <TextInput source="personalKollenTokens.workPeriod" />
      <TextInput source="personalKollenTokens.sales" />
      <TextInput source="personalKollenTokens.reservations" />
      {/* <TextInput source="extOrderData.appId" /> */}
      <SelectInput
        source="it.operations"
        choices={[
          { name: 'GlobalConnect', id: 'globalconnect' },
          { name: 'Other', id: 'other' },
        ]}
        options={{ fullWidth: true }}
      />
      <SelectInput
        source="it.primaryNetwork" // Fiber
        choices={[
          {
            name: 'Telia',
            id: 'telia',
          },
          { name: 'Other', id: 'other' },
        ]}
        options={{ fullWidth: true }}
      />
      <SelectInput
        source="it.backupNetwork" // 4G
        choices={[
          { name: 'Telia 4G', id: 'telia4G' },
          {
            name: 'Other',
            id: 'other',
          },
          { name: 'None', id: 'none' },
        ]}
        options={{ fullWidth: true }}
      />
      <SelectInput
        source="it.printerServer" // Printer server
        choices={[
          { name: 'Server 1 (currently in use)', id: 'printerest-globalconnect.pinchos.se:3000' },
          { name: 'Server 2 (vacant)', id: 'server2' },
          { name: 'Server 3 (currently in use)', id: 'printerest-globalconnect3.pinchos.se:3000' },
          { name: 'Server 4 (vacant)', id: 'server4' },
          { name: 'Server 5 (vacant)', id: 'server5' },
        ]}
        options={{ fullWidth: true }}
      />
    </FormTab>
  </TabbedForm>
);

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const EditActions = ({ basePath, refresh, translate, ...props }) => (
  <CardActions style={cardActionStyle}>
    <VenueBookingSetup {...props} venueId={props.match.params.id} />
    <VenuePreview {...props} />
    <Link to={`/assortments/${props.match.params.id}`}>
      <FlatButton primary label={translate('productManagement')} />
    </Link>
    <Link to={`/open-hours/${props.match.params.id}`}>
      <FlatButton primary label={translate('openHours')} />
    </Link>
    <SyncPreview {...props} />
    <ListButton basePath={basePath} />
    <FlatButton primary label="Refresh" onClick={refresh} icon={<Refresh />} />
  </CardActions>
);

export const VenueEdit = t((props) => (
  <Edit actions={<EditActions {...props} />} title={<VenueTitle />} {...props}>
    {form('edit', props)}
  </Edit>
));

export const VenueCreate = t((props) => (
  <Create {...props}>{form('create', props)}</Create>
));

const OpenHoursActions = ({ basePath, refresh, translate, ...props }) => (
  <CardActions style={cardActionStyle}>
    <Link to={`/venues/${props.match.params.id}`}>
      <FlatButton primary label={translate('venue')} />
    </Link>
    <Link to={`/assortment/${props.match.params.id}`}>
      <FlatButton primary label={translate('productManagement')} />
    </Link>
    <FlatButton primary label="Refresh" onClick={refresh} icon={<Refresh />} />
  </CardActions>
);

export const VenueOpenHoursEdit = t((props) => (
  <Edit
    actions={<OpenHoursActions {...props} />}
    title={<VenueTitle />}
    {...props}
  >
    <TabbedForm redirect={null}>
      <FormTab label="Standard">
        <div>
          <h1>Restaurant open hours are no longer set here</h1>
          <a href="https://restaurant.pinchos.se/settings/reservation-open-hours">
            <h4>
              Your settings have been moved to the new editor. Go to PN
              Restaurant =&gt; Settings =&gt; Reservation open hours to change
              them
            </h4>
          </a>
        </div>
        {/* <OpenHoursBuilder {...props} type="venue" /> */}
      </FormTab>
      <FormTab label="Take Away">
        <div>
          <h1>Take Away open hours are no longer set here</h1>
          <a href="https://restaurant.pinchos.se/settings/take-away">
            <h4>
              Go to PN Restaurant =&gt; Settings =&gt; Take Away open hours to
              change them
            </h4>
          </a>
        </div>
        {/* <OpenHoursBuilder {...props} type="takeAway" /> */}
      </FormTab>
      <FormTab label="Brunch">
        <BooleanInput source="brunchEnabled" />
        <OpenHoursBuilder {...props} type="brunch" />
      </FormTab>
      <FormTab label="Creperie">
        <OpenHoursBuilder {...props} type="creperie" />
      </FormTab>
      <FormTab label="Creperie Take Away">
        <OpenHoursBuilder {...props} type="creperieTakeAway" />
      </FormTab>
    </TabbedForm>
  </Edit>
));
